import React, { useState, useRef } from 'react';
import {
  Button,
  ButtonGroup,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';

export default function ActionButton(props) {
  const { children, sx, apiRef } = props;
  const [open, setOpen] = useState(false);
  const [forceOpen, setForceOpen] = useState(false);
  const [maxHeight, setMaxHeight] = useState(300);
  const anchorRef = useRef(null);

  if (apiRef)
    apiRef.current = {
      setOpen: () => {
        setOpen(true);
        setForceOpen(true);
      },
    };

  function handleToggle() {
    setOpen((prevOpen) => !prevOpen);

    if (!open) {
      const { top } = anchorRef.current.getBoundingClientRect();
      setMaxHeight(window.innerHeight - top - 60);
    }
  }

  function handleClose(event) {
    if (forceOpen) return setForceOpen(false);
    if (anchorRef.current && anchorRef.current.contains(event.target)) return;
    setOpen(false);
  }

  return (
    <>
      <ButtonGroup
        sx={{ ...sx }}
        disabled={![children].flat().length}
        variant="contained"
        ref={anchorRef}
      >
        <Button onClick={handleToggle}>
          Actions
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>

      <Popper
        sx={{ zIndex: 3 }}
        open={open}
        keepMounted={true}
        anchorEl={anchorRef.current}
        transition
        disablePortal
        placement="bottom-end"
        modifiers={[{ name: 'offset', options: { offset: [0, 8] } }]}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: 'top right' }}>
            <Paper sx={{ minWidth: 160, maxHeight, overflow: 'auto' }}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList>
                  {[children].flat().map((child, index) => (
                    <MenuItem
                      key={index}
                      value={child}
                      onClick={() => {
                        if (!child.props['keep-open'] && !child.props.disabled)
                          handleToggle();
                      }}
                      sx={{
                        p: 0,

                        'body & > div': {
                          width: '100%',
                        },

                        'body & button': {
                          width: '100%',
                          py: 1.5,
                          px: 2,
                          m: 0,
                          justifyContent: 'left',
                          fontWeight: 'normal',
                          color: (theme) => theme.palette.text.primary,
                          borderRadius: 0,

                          ':disabled': {
                            pointerEvents: 'none',
                          },

                          ':hover': {
                            bgcolor: (theme) => theme.palette.primary.main,
                            color: 'white',
                          },
                        },
                      }}
                    >
                      {child}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
